import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  lasMessage: {
    margin: "1em 0",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
    lineHeight: "normal",
    maxHeight: "calc(3 * 1em)",
  },
  badge: {
    float: "right",
    background: palette.error.main,
    color: "white",
    width: "min-content",
    minWidth: spacing(3),
    height: spacing(3),
    padding: 0,
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "150%",
  },
  time: {
    float: "right",
  },
  subName: {
    fontSize: "12px",
    color: grey[500],
  },
  conversation: {
    cursor: "pointer",
    padding: "24px",
    position: "relative",
  },
  selectedConversation: {
    background: "rgba(41, 121, 255, 0.08)",
  },
  split: {
    height: "1px",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    margin: "24px 0",
    position: "absolute",
    bottom: "-24px",
    right: "24px",
    left: "24px",
  },
  truncate: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));
